const Data = [
  {
    name: "Movie App",
    link: "https://all-movie.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/movie-1.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/movie-website",
  },
  {
    name: "Toy tale",
    link: "https://toy-tale.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/toy.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/Toy-Tale",
  },

  {
    name: "Note App",
    link: "https://note-app-1.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/note.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/note-app",
  },
  {
    name: "Music Collection",
    link: "https://music-collection.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/album.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/album-collection",
  },
  {
    name: "Github",
    link: "https://elyasshamal-github-uesrs.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/github.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/github-users",
  },

  {
    name: "movie",
    link: "https://elyas-movie-land.netlify.app/",
    imageUrl:
      "https://github.com/ElyasShamal/elyas-shamal/blob/main/src/Components/project-images/movie-land.jpg.png?raw=true",
    githubUrl: "https://github.com/ElyasShamal/movie-land",
  },
];

export default Data;
